<img
  src="../../images/register-layout/usnews-360-badge.svg"
  class="tw-mx-auto tw-block tw-w-48"
  alt="US News 360 Reviews Best Password Manager"
/>
